// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QiY_","icon":"styles_icon__2VSRa"};